import { useState, useCallback } from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import PageSectionRow from '../../../../shared/components/layouts/PageSectionRow'
import PageSectionGrid from '../../../../shared/components/layouts/PageSectionGrid'
import PageSectionList from '../../../../shared/components/layouts/PageSectionList'
import FormDrawer from '../../../../shared/components/drawers/FormDrawer'
import ServiceEditForm from './ServiceEditForm'

function ServiceGeneralTab({ service, updateService }) {
  const [drawerOpen, setDrawerOpen] = useState(false)

  const handleOpenDrawer = useCallback(() => {
    setDrawerOpen(true)
  }, [])

  const handleCloseDrawer = useCallback(() => {
    setDrawerOpen(false)
  }, [])

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button
          onClick={handleOpenDrawer}
          variant="outlined"
          size="small"
        >
          <FormattedMessage id="dockerServices.editButton" />
        </Button>
      </Box>

      <PageSectionGrid>
        <PageSectionRow
          labelId="dockerServices.show.slug"
          value={service.slug}
        />
        <PageSectionRow
          labelId="dockerServices.show.image"
          value={service.image}
        />
        <PageSectionRow
          labelId="dockerServices.show.expectedState"
          value={service.expectedState}
        />
        {service.currentStatus && (
          <PageSectionRow
            labelId="dockerServices.show.currentStatus"
            value={service.currentStatus.state}
          />
        )}
        {service.restartPolicy && (
          <PageSectionRow
            labelId="dockerServices.show.restartPolicy"
            value={service.restartPolicy}
          />
        )}
        {service.containerName && (
          <PageSectionRow
            labelId="dockerServices.show.containerName"
            value={service.containerName}
          />
        )}
        {service.platform && (
          <PageSectionRow
            labelId="dockerServices.show.platform"
            value={service.platform}
          />
        )}
        <PageSectionRow
          labelId="dockerServices.show.logStreaming"
          value={service.logStreaming ? 'Enabled' : 'Disabled'}
        />
        <PageSectionRow
          labelId="dockerServices.show.createdAt"
          value={
            <FormattedDate
              value={service.createdAt}
              year="numeric"
              month="long"
              day="numeric"
              hour="numeric"
              minute="numeric"
            />
          }
        />
        <PageSectionRow
          labelId="dockerServices.show.updatedAt"
          value={
            <FormattedDate
              value={service.updatedAt}
              year="numeric"
              month="long"
              day="numeric"
              hour="numeric"
              minute="numeric"
            />
          }
        />
      </PageSectionGrid>

      {service.command && service.command.length > 0 && (
        <>
          <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
            <FormattedMessage id="dockerServices.sections.command" />
          </Typography>
          <PageSectionList
            items={service.command.map((cmd, index) => ({ id: index, value: cmd }))}
            emptyId="dockerServices.show.commandEmpty"
            renderItem={(item) => ({
              primary: item.value,
              secondary: null,
            })}
          />
        </>
      )}

      <FormDrawer
        open={drawerOpen}
        onClose={handleCloseDrawer}
        titleId="dockerServices.edit.title"
      >
        <ServiceEditForm
          service={service}
          updateService={updateService}
          onSuccess={handleCloseDrawer}
          onCancel={handleCloseDrawer}
        />
      </FormDrawer>
    </>
  )
}

export default ServiceGeneralTab
